<template>
  <div class="products-page">
      <fancy-header></fancy-header>
      <div class="container ">
          <div class="row">
             <div class="col-xs-12">
               <div class="products-header">
                    <ul class="nav nav-pills">
                        <li role="presentation" :class="{ 'active' : selectedSectionId == 0 }">
                            <a @click="onSectionClick(null)">الكل</a>
                        </li>
                        <li v-for="section in sections" v-bind:key="section.Id" :class="{ 'active' : selectedSectionId == section.Id }">
                            <a @click="onSectionClick(section)">{{section.Title}}</a>
                        </li>
                    </ul>
               </div>
             </div>
             <div class="col-xs-12 min-height">
                 <div class="products-body">
                        <div v-for="product in products" :key="product.Id" class="col-md-3 col-sm-6 col-xs-12">
                            <product-v2 :product="product"></product-v2>
                        </div>
                 </div>
                 <div class="loading getmore-div" v-show="isLoading">
                     <div class="fas fa-spinner fa-spin" >
                    </div>
                 </div>
                 <div class="clearfix"></div>
             </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import FancyHeader from '@/components/shared/fancy-header'
import ProductV2 from '@/components/products/productv2';

export default {
    name:'ProductsIndex',

    components:{
        FancyHeader,
        ProductV2
    },
    
    data: () => ({
        products: [],
         sections: [],
        scrollPosition: null,
        page: 0,
        selectedSectionId: 0,
        isLoading: true,
        noMoreProducts: false
    }),
    
    methods: {
        updateScroll() {
            let scrollTop =window.scrollY,
                winHeight = window.height,
                docHeight = document.height,
                bottomHgt = docHeight - winHeight - scrollTop;
            this.scrollPosition = docHeight = winHeight - scrollTop;

            if(this.scrollPosition <= 120)
            {
                if(this.lastProductId != 0 && this.lastTypeId != 0)
                {
                   
                    this.getMoreProducts();
                }
            }
        },

        fetch() {
            this.isLoading = true;
            this.products = [];
            this.selectedSectionId = 0;

            axios.get(apiHost + "/products?page=" + this.page)
                .then((response) => {
                    this.products = response.data.Products;
                    //this.page++;
                    this.noMoreProducts = !response.data.HasMore;

                    if(response.data.length == 0){
                        this.page = 0;
                        this.noMoreProducts = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    NProgress.done()
                    this.isLoading = false;
                });

        },

        fetchSections(next) {
            axios.get(apiHost + "/sections")
                .then((response) => {
                    this.sections = response.data;
                    NProgress.done();

                    if (typeof(next) == 'function')
                        next();
                })
                .catch((error) => {
                    console.log(error);
                    NProgress.done();
                });    
        },

        onSectionClick(section) {
            if (section == null) 
                this.$router.replace({
                    name: 'products',
                });
            else 
                this.$router.replace({
                    name: 'products',
                    params: {
                        section: section.Title
                    }
                });
        },

        viewSectionProducts(sectionId) {
            NProgress.start();
            this.isLoading = true;
            this.products = [];
            this.selectedSectionId = sectionId;

            if (sectionId == 0)
            {
                this.fetch();
                return;
            }

            axios.get(apiHost + "/sections/" + sectionId + "/products")
                .then((response) => {
                    this.products = response.data;
                    NProgress.done();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => this.isLoading = false);
                
        },

        onRouteChange() {
            if (this.$route.params.section != undefined)
            { 
                var section = this.$route.params.section;
                var sec = this.sections.filter(c => c.Title == section)[0];
                if (sec) 
                    this.viewSectionProducts(sec.Id);
                else
                    this.fetch();                
            }
            else {
                this.fetch();
            }
        }
     },
    mounted() {
        this.sections = this.$parent.sections;
        if (this.sections.length == 0)
            this.fetchSections(() => this.onRouteChange());
        else
            this.onRouteChange();

          var footerheight =  $('.footer').height();
          var headerheight = $('.navbar-inverse').height();
          var height = $(window).height() - (footerheight + headerheight);
           $('.min-height').css({"min-height":height});
    },

    watch: {
        '$route' (to, from) {
            this.onRouteChange();
        }
    }
}
</script>
<style lang="scss">
        @import "src/assets/sass/shared.scss";
        .products-page{
                & > .container{
                    margin-top:30px;
                    margin-bottom:30px;
                }
                .products-header{
                    border-bottom:1px solid silver;
                    padding-bottom:5px;
                    margin-bottom:15px;
                    overflow:auto;
                .nav-pills{
                      @include float-left($dir);

                                &  > li{
                                        @include float-left($dir);
                                        &.active{
                                            a{
                                                    background-color:$main-color;
                                                color:#fff;
                                            }
                                        }
                                        a{
                                            &:hover , &:focus{
                                                color:$main-color;
                                            }
                                        }
                                }
                                & > li.active {
                                    a{
                                        &:hover , &:focus {
                                            color: white;
                                        }
                                    }
                                }
                            }
                }
                .products-body {
                    & > div{
                        @include float-left($dir);
                    }
                }                                   

        }
        .no-more-products{
            text-align: center;
            margin-top:20px;
        }

        .loading.getmore-div{
            text-align:center;
            margin-top:15px;
            .fa-spin{
                font-size:20px;
                color:$main-color;
            }
        }
      
</style>



// WEBPACK FOOTER //
// src/components/products/index.vue